export const isQueryParamFlagsTrue = (queryParamValue: string) =>
  queryParamValue === 'true';
